<div class="insurance-section" [formGroup]="matterAddressForm">
  <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start stretch">
    <mat-form-field appearance="outline" fxFlex="25">
      <mat-label>Insurer</mat-label>
      <input matInput formControlName="INSURER" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="25">
      <mat-label>Policy Number</mat-label>
      <input matInput formControlName="POLICYNUMBER" />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INSURANCEEXPIRYDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INSURANCEEXPIRYDATE),
      }"
    >
      <mat-label>Insurance Expiry Date</mat-label>
      <input
        (dateInput)="ResolutionDatepicker('input', $event)"
        (dateChange)="ResolutionDatepicker('change', $event)"
        name="resolutiondatepicker"
        matInput
        [matDatepicker]="resolutiondatepicker"
        formControlName="INSURANCEEXPIRYDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="resolutiondatepicker"></mat-datepicker-toggle>
      <mat-datepicker #resolutiondatepicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="25">
      <mat-label>Minimum Insurance</mat-label>
      <input
        matInput
        formControlName="MINIMUMINSURANCE"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="32px" class="checkbox-row">
    <mat-checkbox formControlName="BUSHFIREPRONE">Bushfire Prone</mat-checkbox>
    <mat-checkbox formControlName="FLOODPRONE">Flood Prone</mat-checkbox>
    <mat-checkbox formControlName="CYCLONEPRONE">Cyclone Prone</mat-checkbox>
  </div>
</div>
